// Temporary feature toggles.
// Set to true when bill OCR should be re-enabled.
export const BILL_OCR_ENABLED = false;

